import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import PoweredByFooter from "../common/PoweredByFooter";
import {
  Container, Header, FormField, Input, Button,
  SpaceBetween, Alert, Box,
} from "@cloudscape-design/components";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");
  const { adminLogin } = useAuth();
  const history = useHistory();
  const companylogo = process.env.REACT_APP_ADMIN_LOGO || "/Assets/images/iWMS.png";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { setError("Enter email and password."); return; }
    setLoading(true);
    setError("");
    try {
      await adminLogin(email, password);
      history.replace("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Invalid admin credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <PoweredByFooter dark />
      </div>
      <div style={styles.card}>
        <SpaceBetween size="l">
          <Box textAlign="center">
            <img src={"/Assets/images/iWMSLogo_white.png"} alt="iWMS" style={{ height: 50, marginBottom: 16 }} />
            <h1 style={styles.logo}>SmartOps Admin</h1>
            <p style={styles.subtitle}>Warehouse Management Suite</p>
          </Box>

          <Container header={<Header variant="h2">Sign In</Header>}>
            <form onSubmit={handleSubmit}>
              <SpaceBetween size="m">
                {error && <Alert type="error">{error}</Alert>}

                <FormField label="Email">
                  <Input
                    value={email}
                    onChange={({ detail }) => setEmail(detail.value)}
                    placeholder="admin@iwms.com"
                    autoFocus
                  />
                </FormField>

                <FormField label="Password">
                  <div style={{ position: "relative" }}>
                    <Input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={({ detail }) => setPassword(detail.value)}
                      placeholder="••••••••"
                    />
                    <div style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)" }}>
                      <Button variant="link" formAction="none" onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? "Hide" : "Show"}
                      </Button>
                    </div>
                  </div>
                </FormField>

                <Button
                  variant="primary"
                  formAction="submit"
                  loading={loading}
                  fullWidth
                >
                  Sign In as Admin
                </Button>
                <Box textAlign="center">
                  <Button variant="link" onClick={() => history.push("/login")}>
                    Back to user login
                  </Button>
                </Box>
              </SpaceBetween>
            </form>
          </Container>
        </SpaceBetween>
      </div>

    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #0f1b2d 0%, #1b2f4b 100%)",
  },
  card: {
    width: "100%",
    maxWidth: 440,
    padding: "0 16px",
  },
  logo: {
    color: "#fff",
    fontSize: 28,
    fontWeight: 700,
    margin: 0,
    letterSpacing: 1,
  },
  subtitle: {
    color: "rgba(255,255,255,0.6)",
    marginTop: 4,
    fontSize: 14,
  },
  linkText: {
    fontSize: 14,
    color: "#666",
  },
  link: {
    color: "#0073bb",
    textDecoration: "none",
    fontWeight: 600,
  },
};
